import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { App as AntApp } from 'antd';
import './App.css';

// 导入页面组件
import Login from './pages/login';
import routes from './router';

// 路由守卫组件
const RequireAuth: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const token = localStorage.getItem('token');
  
  console.log('路由守卫检查:', {
    path: location.pathname,
    hasToken: !!token,
    token: token ? '已存在' : '不存在',
    timestamp: new Date().toISOString()
  });
  
  if (!token) {
    console.log('未登录，重定向到登录页');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  return <>{children}</>;
};

const App: React.FC = () => {
  return (
    <AntApp>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          
          {routes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={
                <RequireAuth>
                  {route.element}
                </RequireAuth>
              }
            >
              {route.children?.map((child, childIndex) => (
                <Route
                  key={childIndex}
                  path={child.path}
                  element={child.element}
                />
              ))}
            </Route>
          ))}
          
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
    </AntApp>
  );
};

export default App;
